// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VcaWrTCKGBlyUQ {
  position: sticky;
  top: var(--ds-space-400, 32px);
  flex-shrink: 0;
  align-self: flex-start;
  width: 240px;
  margin-right: var(--ds-space-400, 32px);
  padding: var(--ds-space-0, 0) var(--ds-space-200, 16px);
  overflow: auto;
}
.VcaWrTCKGBlyUQ li {
  margin: var(--ds-space-025, 2px) var(--ds-space-0, 0);
}
.Tj_8mXpFUfaPCe {
  display: none;
  position: sticky;
  top: var(--ds-space-0, 0);
  justify-content: space-between;
  height: 16px;
  margin-bottom: var(--ds-space-200, 16px);
  padding: var(--ds-space-200, 16px) var(--ds-space-200, 16px);
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  font-weight: var(--ds-font-weight-bold, bold);
  cursor: pointer;
}
._Z26_5ulunuq9z {
  width: 30px;
  font-size: 20px;
}
.JK2IGZpq_OmFl9 {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  flex: 1 1 auto;
  margin: var(--ds-space-0, 0);
  margin-top: var(--ds-space-0, 0);
}
.HxeLWkgQ12vFf1 {
  display: flex;
  align-items: center;
  min-height: 24px;
  padding: var(--ds-space-050, 4px) var(--ds-space-100, 8px);
  overflow: hidden;
  border-radius: 4px;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}
.HxeLWkgQ12vFf1:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  color: var(--ds-text, #172b4d);
}
.HxeLWkgQ12vFf1.IA62wcHs6TaeTM {
  padding-left: var(--ds-space-400, 32px);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-regular, normal);
}
.MWlzfJys4hNLqv {
  display: block;
  flex: 0 0 auto;
  margin-right: var(--ds-space-100, 8px);
  text-align: center;
}
.g9oPwIIH6rBx2f.HxeLWkgQ12vFf1 {
  background-color: var(--ds-background-selected, #e9f2ff);
  font-weight: var(--ds-font-weight-bold, bold);
}
.g9oPwIIH6rBx2f.HxeLWkgQ12vFf1,
.g9oPwIIH6rBx2f.HxeLWkgQ12vFf1:hover,
.g9oPwIIH6rBx2f.HxeLWkgQ12vFf1 .MWlzfJys4hNLqv {
  color: var(--ds-icon-selected, #0c66e4);
}
.SaYYOs6KzcAbyW {
  margin-bottom: var(--ds-space-300, 24px);
}
.fd8hBa4obpdFrY .SaYYOs6KzcAbyW {
  padding: var(--ds-space-0, 0) var(--ds-space-100, 8px);
}
.SSNwXRrxBq_ydG {
  margin-right: var(--ds-space-100, 8px);
}
.zg11U26A8bhrZC {
  display: grid;
  grid-template-columns: 40px 1fr;
  align-items: center;
  margin-bottom: var(--ds-space-100, 8px);
}
.jrvF3AoyRlxq9n {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-size: cover;
}
.UYgPc5QlTPxXoS {
  margin-left: var(--ds-space-100, 8px);
  overflow: hidden;
  font-size: 16px;
  font-weight: var(--ds-font-weight-bold, 700);
  text-overflow: ellipsis;
}
.EaNufO7hsPdK7V {
  margin-left: var(--ds-space-150, 12px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `VcaWrTCKGBlyUQ`,
	"responsiveNavigator": `Tj_8mXpFUfaPCe`,
	"responsiveNavigatorIcon": `_Z26_5ulunuq9z`,
	"navigationSectionHeading": `JK2IGZpq_OmFl9`,
	"navigationLink": `HxeLWkgQ12vFf1`,
	"categoryLink": `IA62wcHs6TaeTM`,
	"navigationLinkIcon": `MWlzfJys4hNLqv`,
	"isActive": `g9oPwIIH6rBx2f`,
	"navigationSection": `SaYYOs6KzcAbyW`,
	"expanded": `fd8hBa4obpdFrY`,
	"backIcon": `SSNwXRrxBq_ydG`,
	"powerUpHeader": `zg11U26A8bhrZC`,
	"powerUpIcon": `jrvF3AoyRlxq9n`,
	"powerUpName": `UYgPc5QlTPxXoS`,
	"powerUpSettings": `EaNufO7hsPdK7V`
};
export default ___CSS_LOADER_EXPORT___;
